import { useEffect, useEffectEvent } from 'react';

export const useLoadingBackstop = (
  isLoading: boolean,
  src: string,
  onExpire: () => void,
  maxLoadingMs: number
): void => {
  const handleExpire = useEffectEvent(onExpire);
  const loadingSrc = isLoading ? src : null;

  useEffect(() => {
    if (loadingSrc === null) return undefined;
    const timer = window.setTimeout(() => handleExpire(), maxLoadingMs);
    return () => window.clearTimeout(timer);
  }, [loadingSrc, maxLoadingMs]);
};
